const TRAILING_ID_LIST = /:\s*\[[^\]]*\]\s*$/

export function apiErrorMessage(error, fallback, companies = []) {
  const body = error?.response
  if (typeof body?.message === 'string') {
    if (!Array.isArray(body.companyIds) || !body.companyIds.length) return body.message
    const names = body.companyIds.map(
      (id) => companies.find((company) => String(company.id) === String(id))?.name ?? String(id)
    )
    return body.message.replace(TRAILING_ID_LIST, () => `: ${names.join(', ')}`)
  }
  const [firstNonField] = Array.isArray(body?.nonFieldErrors) ? body.nonFieldErrors : []
  return typeof firstNonField === 'string' ? firstNonField : fallback
}
